// removed by extract-text-webpack-plugin
module.exports = {"companyCell":"_3fYW3zL8Fdr1FQ4MpJCa9h","content":"_1wIH_NuC9Z5HcmrnBsppCx","logo":"_2qsBo9IgJxvn4DF2RV62ic","about":"_3ggmgxITqAplNa5fmZ9FPi","title":"_3inm2Mf8crFVCJl-TwAyOR","defaultLang":"_1vWiB2-uLF-xdBbtbN-aHp","description":"_23LiLjmvXWEKJtIJGjyNSe","moreInfo":"mLaAcb1ZeQPBsLHpzH6D7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyCellMobile/CompanyCellMobile.scss
// module id = 1581
// module chunks = 0